import { Reward } from "../types/reward.entity";
import { isTremendousRewardProductMetadata } from "./tremendous";

export const getRewardPayoutLabel = (reward: Reward): string | null => {
  const metadata = reward.provider.productMetadata as Record<string, unknown> | undefined;

  if (isTremendousRewardProductMetadata(metadata)) {
    return `${metadata.currencyCode} ${metadata.denomination}`;
  }

  const currency = typeof metadata?.currency === "string" ? metadata.currency : null;
  const amount = typeof metadata?.amount === "number" ? metadata.amount : null;

  if (!currency || amount === null) return null;

  return `${currency} ${amount}`;
};
